/* eslint-disable no-console, no-undef */
import Glide from '../vendors/glide.min';

window.RESET_GLIDE_EVENT = 'reset-glide';
window.resetGlideEvent = new Event(window.RESET_GLIDE_EVENT);

const gridSliders = () => {
  if (document.querySelectorAll('.grid-slider').length === 0) {
    return;
  }

  const sliders = [];
  let enabled = false;

  const init = () => {
    [].map.call(document.querySelectorAll('.grid-slider'), (slider) => {
      // Set autoplay from global param, then check to see if local setting was passed
      let autoplay = window.autoplayInterval;
      if (!autoplay) {
        autoplay = 0;
      }
      if (slider.getAttribute('data-glide-autoplay')) {
        autoplay = parseInt(slider.getAttribute('data-glide-autoplay'), 10);
      }
      // Is there more than 1 slide
      if (slider.querySelectorAll('.glide__slide').length > 1) {
        // Add glide
        const glide = new Glide(slider, {
          type: 'carousel',
          startAt: 0,
          gap: 0, // 30
          autoplay,
          hoverpause: true,
          breakpoints: {
            991: {
              perView: 3,
              focusAt: 0,
            },
            767: {
              perView: 3,
              focusAt: 0,
            },
            575: {
              perView: 2,
              focusAt: 0,
            },
            399: {
              perView: 1,
              focusAt: 0,
            },
          },
        });
        glide.mount();
        sliders.push(glide);
      }
    });
  };

  const destroy = () => {
    sliders.forEach((slider) => {
      slider.destroy();
    });
    sliders.splice(0, sliders.length);
  };

  const updateGlideEvents = () => {
    if (window.innerWidth <= 991 && !enabled) {
      enabled = true;
      init();
    }
    if (window.innerWidth > 991 && enabled) {
      enabled = false;
      destroy();
    }
  };

  window.addEventListener('resize', () => {
    updateGlideEvents();
  });

  window.addEventListener(window.RESET_GLIDE_EVENT, () => {
    updateGlideEvents();
  });

  updateGlideEvents();
};

export default gridSliders;
/* eslint-enable no-console, no-undef */
